import { getTenant, getUserName } from '../helpers';
import { api } from './api';

export function getRecommendedCoursesAPI(searchTerm, callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdaimentorapi.aiMentorOrgsUsersRecommendCoursesRetrieve(
        ...(args || [])
      ),
    getTenant(),
    getUserName(),
    {
      returnCourseData: true,
      searchTerms: searchTerm,
      includeLearnerSkills: false,
    }
  )((err, data, response) => filterRecommendedCourseData(data, callback));
}

function filterRecommendedCourseData(data, callback) {
  const recommendedCourses = [];
  if ( data?.courses && Array.isArray(data?.courses)){
    for (let i = 0; i < data.courses.length && i < 5; i++) {
      const course = data.courses[i];
      recommendedCourses.push(course);
    }

  }

  callback(recommendedCourses);
}
